import React, { Component } from "react";

class Stuff extends Component {
	render() {
		return (
			<div>
				<h2>Support</h2>
				<p>Support for Optify.</p>
			</div>
		);
	}
}

export default Stuff;
